import { isTablet } from '../../utils/responsive';

/* Body animation handlers */

export const handleBodyAnimationsClosed = (hostElement: HTMLElement) => {
	const elementsToAnimate = hostElement.querySelectorAll<HTMLElement>('[data-zds-navigation-body-animate]');
	const animateFunc = isTablet() ? animateBodyElementClosedMobile : animateElementClosedDesktop;
	elementsToAnimate.forEach((elementToAnimate) => {
		animateFunc(elementToAnimate);
	});
};

export const handleBodyAnimationsOpen = (hostElement: HTMLElement) => {
	const elementsToAnimate = hostElement.querySelectorAll<HTMLElement>('[data-zds-navigation-body-animate]');
	const animateFunc = isTablet() ? animateBodyElementOpenMobile : animateElementOpenDesktop;
	elementsToAnimate.forEach((elementToAnimate, index) => {
		animateFunc(elementToAnimate, index);
	});
};

/* Panel animation handlers */

export const handlePanelAnimationsClosed = (hostElement: HTMLElement) => {
	const elementsToAnimate = hostElement.querySelectorAll<HTMLElement>('[data-zds-navigation-panel-animate]');
	const animateFunc = isTablet() ? animatePanelElementClosedMobile : animateElementClosedDesktop;
	elementsToAnimate.forEach((elementToAnimate) => {
		animateFunc(elementToAnimate);
	});
};

export const handlePanelAnimationsOpen = (hostElement: HTMLElement) => {
	const elementsToAnimate = hostElement.querySelectorAll<HTMLElement>('[data-zds-navigation-panel-animate]');
	const animateFunc = isTablet() ? animatePanelElementOpenMobile : animateElementOpenDesktop;
	elementsToAnimate.forEach((elementToAnimate, index) => {
		animateFunc(elementToAnimate, index);
	});
};

/* Desktop animations */

const animateElementClosedDesktop = (elementToAnimate: HTMLElement) => {
	elementToAnimate.style.opacity = '0';
	elementToAnimate.style.transition = 'opacity 300ms var(--zds-transition-type-ease-out)';
};

const animateElementOpenDesktop = (elementToAnimate: HTMLElement) => {
	elementToAnimate.style.opacity = '1';
	elementToAnimate.style.transition = 'opacity 300ms var(--zds-transition-type-ease-in)';
};

/* Mobile animations: body elements */

const animateBodyElementClosedMobile = (elementToAnimate: HTMLElement) => {
	elementToAnimate.style.opacity = '0';
	elementToAnimate.style.transform = 'translateY(-8px)';
	elementToAnimate.style.transition = 'opacity var(--zds-transition-md), transform var(--zds-transition-md)';
};

const animateBodyElementOpenMobile = (elementToAnimate: HTMLElement, index: number) => {
	setTimeout(() => {
		elementToAnimate.style.opacity = '1';
		elementToAnimate.style.transform = 'none';
	}, index * 20);
};

/* Mobile animations: panel elements */

const animatePanelElementClosedMobile = (elementToAnimate: HTMLElement) => {
	elementToAnimate.style.opacity = '0';
	elementToAnimate.style.transform = 'translateX(25px)';
	elementToAnimate.style.transition = 'opacity var(--zds-transition-md), transform var(--zds-transition-md)';
};

const animatePanelElementOpenMobile = (elementToAnimate: HTMLElement, index: number) => {
	setTimeout(
		() => {
			elementToAnimate.style.opacity = '1';
			elementToAnimate.style.transform = 'none';
		},
		100 + index * 20,
	);
};
